import React from 'react';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';

/**
 * Reusable bulk delete confirmation dialog (Wrapper for DeleteConfirmationDialog)
 *
 * @param {boolean} open - Dialog open state
 * @param {Function} onClose - Handler to close dialog
 * @param {Function} onConfirm - Handler for delete confirmation
 * @param {number} count - Number of items to delete
 * @param {string} itemName - Name of items (e.g., 'contacts', 'campaigns')
 * @param {boolean} deleting - Whether deletion is in progress
 * @param {React.ReactNode} children - Optional custom content to display in dialog
 */
export default function BulkDeleteDialog({
  open,
  onClose,
  onConfirm,
  count,
  itemName = 'items',
  deleting = false,
  children,
}) {
  return (
    <DeleteConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      count={count}
      itemName={itemName}
      deleting={deleting}
    >
      {children}
    </DeleteConfirmationDialog>
  );
}
